module.exports = __webpack_public_path__ + "static/media/1023531.ff9be749.png";